import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import type { MessageKey } from 'types/LocaleMessageKey';

import Image from '@/app/components/Image';

import FeatureHighlight from './FeatureHighlight';

interface Props {
  readonly title?: ReactNode;
  readonly body?: ReactNode;
  readonly src: MessageKey;
  readonly alt?: MessageKey;
  readonly loading?: 'lazy' | 'eager';
  readonly reverse?: boolean | undefined;
  readonly children?: ReactNode;
  readonly icon?: ReactNode;
}

const Feature = ({
  title,
  body,
  src: srcKey,
  alt: altKey,
  loading = 'lazy',
  reverse,
  children = <></>,
  icon = <></>,
}: Props) => {
  const t = useTranslations();

  return (
    <FeatureHighlight
      contentElement={
        <>
          {icon}
          {title && (
            <Typography
              data-cy="lp-feature-title"
              variant="h6"
              Element="h3"
              className="mb-4"
              weight="normal"
              color="inherit"
            >
              {title}
            </Typography>
          )}

          {body && (
            <Typography data-cy="lp-feature-body" color="inherit">
              {body}
            </Typography>
          )}

          {children}
        </>
      }
      deviceContent={
        <Image
          alt={t(altKey!)}
          src={t(srcKey)}
          format="png"
          loading={loading}
          width={270}
          height={584}
        />
      }
      reverse={reverse}
    />
  );
};

export default Feature;
